// text-brand-white (not content-inverse) keeps the label legible on the blue
// hover fill in dark theme, where content-inverse resolves to black.
export const NAV_SHOP_CTA_CLASSES =
  "rounded-full bg-content-primary font-ppMori text-nav-label-sm text-content-inverse transition-colors duration-quick hover:bg-brand-blue hover:text-brand-white motion-reduce:transition-none";
